// Lib
import { firstStatsTasks } from '@/lib/firstStats/firstStatsTasks';

// Components
import Layout from '@/components/composite/FirstStats/Layout';

const Loading = () => {
    return (
        <Layout className="h-full w-full">
            <Layout.MainContent>
                <div
                    className="mb-5 h-10 w-full animate-pulse rounded-md bg-gray-100 dark:bg-icoDarkMode-deepBlack"
                    data-testid="first-stats-loading"></div>
                <div className="mb-2 h-5 w-full animate-pulse rounded-md bg-gray-100 dark:bg-icoDarkMode-deepBlack"></div>
                <div className="mb-10 h-5 w-1/2 animate-pulse rounded-md bg-gray-100 dark:bg-icoDarkMode-deepBlack"></div>
                <div className="flex flex-col space-y-4">
                    {Object.keys(firstStatsTasks).map((taskSlug) => (
                        <div
                            key={taskSlug}
                            className="h-20 w-full animate-pulse rounded-md bg-gray-100 dark:bg-icoDarkMode-deepBlack"></div>
                    ))}
                </div>
            </Layout.MainContent>
            <Layout.SideContent>
                <div className="flex flex-col space-y-10">
                    <div>
                        <div className="mb-2 h-3 w-1/2 animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                        <div className="mb-2 h-5 w-2/3 animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                        <div className="mb-2 h-1.75 w-full animate-pulse rounded-full bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                    </div>
                    <div className="flex flex-col space-y-5">
                        {Object.keys(firstStatsTasks).map((taskSlug) => (
                            <div
                                key={taskSlug}
                                className="h-6 w-full animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                        ))}
                    </div>
                    <div>
                        <div className="mb-3 h-12 w-full animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                        <div className="mb-2 h-3 w-full animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                        <div className="h-3 w-full animate-pulse rounded-md bg-gray-200 dark:bg-icoDarkMode-deepBlack"></div>
                    </div>
                </div>
            </Layout.SideContent>
        </Layout>
    );
};

export default Loading;
